<script lang="ts">
  import Portal from "./Portal.svelte";
</script>

<Portal>
  <div class="fixed z-10 top-0 left-0 right-0 h-12" style="height: 4rem;">
    <slot />
  </div>
</Portal>
